import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-global-non-standard-product-config',
  standalone: false,
  templateUrl: './global-non-standard-product-config.component.html',
  styleUrls: ['./global-non-standard-product-config.component.scss']
})
export class GlobalNonStandardProductConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;
  constructor() { }

  /**
   * Primary key : storeId, globalSupplierId + supplierReference
fields - storeId, globalSupplierId, supplierReference, plu, confidence, is_locked
lookup storeId and globalSupplierId fields
   */

  ngOnInit() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-non-standard-product',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'storeId', header: 'Store ID', type: ColumnType.MultiSelectComplex, setUrl: 'store/lookup' , isReadonly: true, isPrimary: true  },
        { field: 'globalSupplierId', header: 'Global Supplier ID', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier/lookup' , isReadonly: true, isPrimary: true  },
        { field: 'departmentId', header: 'Department ID', type: ColumnType.DropDown, setUrl: 'global-department/lookup', isReadonly: true, isPrimary: true },
        { field: 'supplierReference', header: 'Supplier Reference', type: ColumnType.String, isReadonly: true, isPrimary: true },
        { field: 'plu', header: 'PLU', type: ColumnType.String },
        { field: 'confidence', header: 'Confidence', type: ColumnType.String },
        { field: 'isLocked', header: 'Is Locked?', type: ColumnType.Boolean },
      ],
      addFormConfig: {
        header: 'Add Global Non Standard Product'
      },
      isConfigurable: true
    };
  }
}
